import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@cedarjs/web";
import { 
  Box, 
  Typography, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Chip, 
  Button 
} from "@mui/material";
import { useAuth } from "src/auth";
import { useConfigurationStore, useStateStore } from "src/lib/store";

const GET_ALL_ROLES_QUERY = gql`
  query GetAllRoles {
    roles {
      id
      name
      description
      permissions {
        id
        resource
        read
        create
        update
        delete
      }
    }
  }
`;

const RoleOverride = (props) => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const { roleOverride, setRoleOverride, resetRoleOverride } = useConfigurationStore();
  const site = useStateStore(state => state.site);
  
  // Query all roles for super admin
  const { data: rolesData } = useQuery(GET_ALL_ROLES_QUERY, {
    skip: !currentUser?.isSuperAdmin
  });

  const handleRoleOverrideChange = (event: any) => {
    const selectedRoleIds = event.target.value;
    const selectedRoles = rolesData?.roles?.filter(role => selectedRoleIds.includes(role.id)).map(role => ({
      ...role,
      idSite: site?.id || null // Associate with current site
    })) || [];
    setRoleOverride(selectedRoles);
  };

  const handleResetRoleOverride = () => {
    resetRoleOverride();
  };

  // Don't render if user is not super admin
  if (!currentUser?.isSuperAdmin) {
    return null;
  }

  return (
    <Box className={props.className}>
      
      <FormControl fullWidth size="small" className="mb-2">
        <InputLabel>{t("labels.temporaryRoleOverride")}</InputLabel>
        <Select
          multiple
          value={roleOverride.selectedRoles.map(role => role.id)}
          onChange={handleRoleOverrideChange}
          label={t("labels.temporaryRoleOverride")}
          renderValue={(selected) => (
            <Box className="flex flex-wrap gap-1">
              {(selected as number[]).map((roleId) => {
                const role = rolesData?.roles?.find(r => r.id === roleId);
                return (
                  <Chip
                    key={roleId}
                    label={role?.name}
                    size="small"
                    // className="max-w-[100px]"
                  />
                );
              })}
            </Box>
          )}
        >
          {rolesData?.roles?.map((role) => (
            <MenuItem key={role.id} value={role.id}>
              <Box>
                <Typography variant="body2">{role.name}</Typography>
                {role.description && (
                  <Typography variant="caption" className="text-gray-500">
                    {role.description}
                  </Typography>
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {false && (
        <Typography variant="caption" className="text-gray-500 mb-2 block">
          {site.name}
        </Typography>
      )}
      {roleOverride.selectedRoles.length > 0 && (
        <Button
          size="small"
          color="warning"
          onClick={handleResetRoleOverride}
        >
          {t("actions.resetToSuperAdmin")}
        </Button>
      )}
    </Box>
  );
};

export default RoleOverride;